import React from "react";

export const AccessDenied = () => {
  return (
    <div className="accessDeniedWrapper">
      <div className="accessDenied">
        <p>
          Please contact your Concept BIU client servicing contact to get the
          details about this service.
        </p>
      </div>
    </div>
  );
};
